import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Check, Upload } from "lucide-react";
import React, { useState } from "react";
import toast from "react-hot-toast";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import formatDateAndTime from "../../common/formatDateAndTime";

const Addissuetransaction = ({
  getIssueGenericTransactionAPI,
  selectedRow,
  issueGenericTransaction,
  handleImageOpen,
  getIssueDetailAPI,
  issueDetails,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const resourceTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.resourceTypes;
  const [form, setForm] = useState({});
  const [uploadedImages, setUploadedImages] = useState(null);

  const tranactionFields = [
    {
      label: "Transaction ID",
      value: "transactionid",
      type: "text",
      disabled: false,
    },
    {
      label: "Payment Mode",
      value: "paymentmode",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "cash", value: "Cash" },
        { key: "cheque", value: "Cheque" },
        { key: "credit card", value: "Credit Card" },
        { key: "debit card", value: "Debit Card" },
        { key: "net banking", value: "Net Banking" },
        { key: "upi", value: "UPI" },
      ],
    },
    {
      label: "Transaction Charges",
      value: "transactioncharges",
      type: "text",
      disabled: false,
    },
    {
      label: "Payable Amount",
      value: "payableamount",
      type: "text",
      disabled: false,
    },
    {
      label: "Payment Remarks",
      value: "paymentremarks",
      type: "text",
      disabled: false,
    },
    {
      label: "Upload Image",
      value: "uploadimage",
      type: "file",
      disabled: false,
    },
  ];

  const handleChange = async (field, value) => {
    if (field !== "uploadimage") {
      setForm((prev) => ({ ...prev, [field]: value }));
    } else {
      await uploadmutiplefile(value, "vehicles", "vehicle").then((res) => {
        let filterImages = res?.uploaded?.map((image) => image?.url);
        setUploadedImages(filterImages);
        setForm((prev) => ({
          ...prev,
          image: res?.uploaded || "",
        }));
      });
    }
  };

  const addTransactions = async () => {
    if (!form?.transactionid) {
      return toast.error("Enter Transaction Id", {
        position: "bottom-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "50px",
        },
      });
    }
    if (!form?.payableamount || !/^\d+$/.test(form.payableamount)) {
      return toast.error("Enter a valid amount (numbers only)", {
        position: "bottom-center",
        style: {
          background: "white",
          color: "red",
          fontWeight: "medium",
          marginBottom: "50px",
        },
      });
    }
    if (!form?.paymentremarks) {
      return toast.error("Enter Payment Remarks", {
        position: "bottom-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "50px",
        },
      });
    }
    if (!form?.paymentmode) {
      return toast.error("Select Payment Mode", {
        position: "bottom-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "50px",
        },
      });
    }
    if (!form?.image) {
      return toast.error("Upload Transaction Image", {
        position: "bottom-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "50px",
        },
      });
    }
    try {
      const response = await fetch(`${apiUrl}/api/generictransactions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          resourceType: "vehicleIssues",
          resourceId: selectedRow?.id,
          transactionId: form?.transactionid,
          transactionCharges: Number(form?.transactioncharges),
          methodOfTransaction: form?.paymentmode,
          amount: Number(form?.payableamount),
          transactionRemark: form?.paymentremarks,
          transactionType: "debit",
          updateObject: {
            amountPaid: Number(form?.payableamount),
            id: selectedRow?.id,
            resourceType: "vehicleIssues",
          },
          attachments: JSON.stringify(form?.image),
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setForm({});
        setUploadedImages(null);
        toast.success("Transaction Details Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        await getIssueDetailAPI(selectedRow?.id);
        await getIssueGenericTransactionAPI(selectedRow?.id);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  return (
    <>
      <div className="p-4 mt-6">
        <div className="flex-1">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {tranactionFields.map((field, index) => (
              <div key={index} className="group">
                <label className="block mb-2 font-semibold text-gray-700 text-sm">
                  {field.label}
                  {field.required && (
                    <span className="text-red-500 ml-1">*</span>
                  )}
                </label>

                {field.type === "dropdown" ? (
                  <FormControl
                    fullWidth
                    size="small"
                    className="transition-all duration-200 hover:shadow-md"
                  >
                    <InputLabel id={`drop-label-${index}`}>
                      {field?.label}
                    </InputLabel>
                    <Select
                      labelId={`drop-label-${index}`}
                      value={form[field.value] || ""}
                      onChange={(e) =>
                        handleChange(field.value, e.target.value)
                      }
                      label={field?.label}
                      sx={{
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#e5e7eb",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#818cf8",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6366f1",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 240,
                            borderRadius: "8px",
                            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                          },
                        },
                      }}
                    >
                      {field?.subCategory
                        ?.filter((opt) => opt.item !== "inverted") // optional safety
                        .map((option, idx) => (
                          <MenuItem
                            key={idx}
                            value={option.key ?? option.label ?? option.value}
                          >
                            {option.value}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                ) : field.type === "file" ? (
                  <div className="space-y-3">
                    <div className="relative">
                      <input
                        disabled={field.disabled}
                        type="file"
                        id={`file-${index}`}
                        multiple
                        onChange={(e) =>
                          handleChange(field.value, e.target.files)
                        }
                        className="hidden"
                        accept="image/*"
                      />
                      <label
                        htmlFor={`file-${index}`}
                        className={`flex items-center justify-center gap-2 w-full border-2 border-dashed rounded-lg p-4 transition-all duration-200 ${
                          field.disabled
                            ? "bg-gray-100 cursor-not-allowed"
                            : "border-indigo-300 hover:border-indigo-500 hover:bg-indigo-50 cursor-pointer"
                        }`}
                      >
                        <Upload size={20} className="text-indigo-600" />
                        <span className="text-sm text-gray-600">
                          {form[field.value] ? "Change file" : "Upload file"}
                        </span>
                      </label>
                    </div>
                    {/* {form[field.value] && (
                      <div className="relative rounded-lg overflow-hidden shadow-md border-2 border-gray-200">
                        <img
                          src={
                            form[field.value].Location ||
                            form[field.value].path ||
                            form[field.value].url
                          }
                          className="w-full h-32 object-cover"
                          alt="Preview"
                        />
                        <div className="absolute top-2 right-2 bg-green-500 text-white p-1 rounded-full">
                          <Check size={16} />
                        </div>
                      </div>
                    )} */}
                  </div>
                ) : (
                  <input
                    disabled={field.disabled}
                    type={field.type}
                    value={form[field.value] || ""}
                    onChange={(e) => handleChange(field.value, e.target.value)}
                    className={`w-full border rounded-lg px-4 py-2.5 text-sm transition-all duration-200 ${
                      field.disabled
                        ? "bg-gray-100 cursor-not-allowed"
                        : "border-gray-300 hover:border-indigo-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                    } outline-none`}
                    placeholder={`Enter ${field.label.toLowerCase()}`}
                  />
                )}
              </div>
            ))}
          </div>

          {uploadedImages && uploadedImages?.length > 0 ? (
            <div className="mt-6 flex gap-4 flex-wrap">
              {uploadedImages.map((image, index) => (
                <img
                  key={index}
                  src={image?.url || image?.Location || image?.path || image}
                  alt="Image Preview"
                  className="w-44 h-44 rounded-lg object-cover border shadow"
                />
              ))}
            </div>
          ) : (
            <div className="mt-6 flex gap-4 flex-wrap">
              <img
                src={uploadedImages}
                alt="Image Preview"
                className="w-44 h-44 rounded-lg object-cover border shadow"
              />
            </div>
          )}

          <div className="flex justify-center mt-8">
            <Button
              sx={{
                bgcolor: "#0c4bc0ff",
                fontWeight: 500,
                px: 2,
                color: "white",
                borderRadius: 1,
                width: "200px",
                cursor: "pointer",
                "&:hover": {
                  bgcolor: "#083a9a",
                },
              }}
              onClick={() => {
                addTransactions();
              }}
            >
              Add Transaction
            </Button>
          </div>
        </div>

        <div className="mt-4">
          <table className="mx-auto bg-white w-full text-sm text-left rounded-lg shadow-lg border border-gray-100 mt-4">
            <thead className="">
              <tr>
                <th className="p-2">Transaction Id</th>
                <th className="p-2">Transaction Charges</th>
                <th className="p-2">Mode of Transaction</th>
                <th className="p-2">Amount</th>
                <th className="p-2">Remark</th>
                <th className="p-2">Created At</th>
                <th className="p-2">Attachments</th>
                {/* <th className="p-2">Created By</th> */}
              </tr>
            </thead>
            <tbody>
              {issueGenericTransaction ? (
                <>
                  {issueGenericTransaction?.map((item, index) => {
                    return (
                      <tr key={item?.id} className="border-b hover:bg-gray-50">
                        <td className="p-2">{item?.transactionId}</td>
                        <td className="p-2">{item?.transactionCharges}</td>
                        <td className="p-2">{item?.methodOfTransaction}</td>
                        <td className="p-2">{"₹" + item?.amount}</td>
                        <td className="p-2">{item?.transactionRemark}</td>
                        <td className="p-2">
                          {formatDateAndTime(item?.createdAt)}
                        </td>
                        <td className="p-2">
                          {item?.attachments &&
                            (() => {
                              try {
                                const parsed = JSON.parse(item.attachments);
                                return (
                                  // <a
                                  //   href={parsed[0]?.url}
                                  //   target="_blank"
                                  //   rel="noopener noreferrer"
                                  // >
                                  //   <img
                                  //     src={parsed[0]?.url}
                                  //     alt="Attachment"
                                  //     className="w-12 h-12 cursor-pointer object-cover rounded"
                                  //   />
                                  // </a>
                                  <img
                                    src={parsed[0]?.url || parsed[0]?.path}
                                    alt="Attachment"
                                    onClick={() => {
                                      handleImageOpen(
                                        parsed[0]?.url || parsed[0]?.path,
                                      );
                                    }}
                                    className="w-12 h-12 cursor-pointer object-cover rounded"
                                  />
                                );
                              } catch {
                                return null;
                              }
                            })()}
                        </td>
                      </tr>
                    );
                  })}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    className="text-center mx-auto p-4 text-gray-500"
                  >
                    No Transaction Details found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Addissuetransaction;
